/**
 * Carries the scan email from the page that collected it to /scan. Session storage rather than the
 * query string because /scan is a shareable URL and an address in it would leak into browser
 * history, referrer headers, and server logs.
 *
 * Reading and clearing are separate so the read stays pure: it happens during render, which React
 * runs twice in development, and a read that consumed the value would come back empty the second
 * time.
 */
const SCAN_EMAIL_KEY = 'bazak:scan-email';

export function stashScanEmail(email: string) {
  try {
    window.sessionStorage.setItem(SCAN_EMAIL_KEY, email);
  } catch {
    // Private browsing and storage-blocking extensions throw here. The visitor is simply asked for
    // the email again on /scan.
  }
}

export function peekScanEmail(): string | undefined {
  try {
    return window.sessionStorage.getItem(SCAN_EMAIL_KEY) ?? undefined;
  } catch {
    return undefined;
  }
}

/** Keeps a handoff from attaching itself to some later scan in the same session. */
export function clearScanEmail() {
  try {
    window.sessionStorage.removeItem(SCAN_EMAIL_KEY);
  } catch {
    // See stashScanEmail.
  }
}
